import type {
  ChartSegmentMeta,
  SampleDemographics,
} from '@digital-twins/shared-types'

function hashTagsRevision(parts: Array<string>): string {
  return parts.join('|')
}

export function buildFallbackChartSegmentMeta(
  canonicalAnalysis?: { sampleDemographics?: SampleDemographics | null } | null,
): ChartSegmentMeta {
  const demographics: SampleDemographics | null =
    canonicalAnalysis?.sampleDemographics ?? null
  const axes = (demographics?.dimensions ?? [])
    .filter((dimension) => (dimension.segments ?? []).length >= 2)
    .map((dimension) => ({
      id: dimension.id,
      label: dimension.label,
      kind: 'exclusive' as const,
      levels: dimension.segments.map((segment) => ({
        id: segment.value,
        label: segment.value,
      })),
    }))
  return {
    axes,
    tagsRevision: hashTagsRevision(axes.map((axis) => axis.id)),
  }
}

export function mergeChartSegmentMeta(
  previous: ChartSegmentMeta | null,
  incoming: ChartSegmentMeta,
): ChartSegmentMeta {
  const previousExclusive = (previous?.axes || []).filter((axis) => axis.kind === 'exclusive')
  const incomingExclusive = incoming.axes.filter((axis) => axis.kind === 'exclusive')
  const exclusive = incomingExclusive.length > 0 ? incomingExclusive : previousExclusive
  const overlapping = incoming.axes.filter((axis) => axis.kind === 'overlapping')
  return {
    ...incoming,
    axes: [...exclusive, ...overlapping],
  }
}
